// extracted by mini-css-extract-plugin
export default {"Dialog":"ControlsDialog-module__Dialog__e6DMmnN"};